import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { css } from '@emotion/react';
import theme from '@styles/theme';
import { LogotypeMainIcon } from 'public/assets';
import { openOldDeepLink } from '@common/utils';

import { OLD_DEEP_LINK } from '@common/values';

const ShareHeader = () => {
  const { t } = useTranslation();
  const router = useRouter();

  const onClickApp = () => {
    openOldDeepLink({ t, router, deepLink: OLD_DEEP_LINK });
  };

  return (
    <>
      <nav css={container}>
        <Link href="/">
          <div className="logo">
            <LogotypeMainIcon className="logo" width={132.3} height={36} />
          </div>
        </Link>

        <button className="button" onClick={onClickApp}>
          {t('share_screen_button_move_to_app')}
        </button>
      </nav>
    </>
  );
};

const container = css`
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  min-height: 4.5em;
  background: ${theme.colors.white};
  width: 800px;
  align-items: center;
  padding: 0 1em;
  z-index: 2;

  @media screen and (max-width: ${theme.devices.mobile}) {
    width: 100%;
  }

  .button {
    height: 2.25em;
    cursor: pointer;
    padding: 0.5em 0.9em;
    font: ${theme.font.body1Normal};
    background: ${theme.colors.white};
    color: ${theme.colors.primary500};
    border: 0.0625em solid ${theme.colors.primary500};
    border-radius: 0.375em;
  }

  .logo {
    cursor: pointer;
    width: 9.1875em;
    height: 3.125em;

    @media (max-width: ${theme.devices.mobile}) {
      width: 8.26875em;
      height: 2.25em;
    }
  }
`;

export default ShareHeader;
